function closeMenu() {
  const navbar = $('.navbar-collapse');
  if (navbar.hasClass('in')) {
    navbar.removeClass('in');
    $('.responsive-toggle').addClass('collapsed');
    const icon = $('.icon-toggle');
    icon.removeClass('fa-times');
    icon.addClass('fa-bars');
  }
}

$(document).ready(function () {
  setFooterScrollClasses();
  const item = $('.list-group a').first();
  if (item) {
    item.trigger('click')
  }

  let scrollTop = 0;
  $(window).scroll(setFooterScrollClasses);

  function setFooterScrollClasses() {
    closeMenu();
    const $window = $(window);
    scrollTop = $window.scrollTop();
    const $subFooter = $('.sub-footer');
    const $containerSubFooter = $('.container-sub-footer');
    if (scrollTop >= 40) {
      $('.navbar').addClass('scrolled-nav');
      $subFooter.addClass('footer-fixed');
      $containerSubFooter.addClass('footer-fixed');
    } else if (scrollTop < 40) {
      $('.navbar').removeClass('scrolled-nav');
      $subFooter.removeClass('footer-fixed');
      $containerSubFooter.removeClass('footer-fixed');
    }
    if ((scrollTop + $window.height() + 100) > $('body').height()) {
      $('.footer-products').fadeOut();
      $subFooter.removeClass('footer-fixed');
      $containerSubFooter.removeClass('footer-fixed');
      $subFooter.addClass('footer-bottom');
    } else {
      $('.footer-products').fadeIn();
      $subFooter.removeClass('footer-bottom');
    }
  }
});

$("#form-budget").submit(function (e) {
  e.preventDefault();
  let url = "budget";
  let data = {
    total: JSON.parse(localStorage.getItem('total')) || 0,
    products: {
      offers: JSON.parse(localStorage.getItem('offers')) || [{
        title: "Nenhum papel adicionado ao orçamento",
        white_paper: {id: 4, quantityA4: 0},
        yellow_paper: {id: 6, quantityA4: 0}
      }],
      supports: JSON.parse(localStorage.getItem('supports')) || [{
        title: "Nenhum suporte adicionado ao orçamento",
        quantity: ''
      }],
    }
  };
  localStorage.clear();
  data = $("#form-budget").serialize() + '&' + $.param(data);
  $.ajax({
    type: "POST",
    url: url,
    data: data,
    success: function (data) {
      $('.modal-store').modal('hide');
      gritter({
        title: 'Orçamento enviado!',
        text: 'Orçamento enviado com sucesso, em breve nossa equipe entrará em contato.',
      }, 'info');
    }
  });

});

window.parseToFloat = function (value) {
  if (value) {
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }
};

window.setProductsBudgetPopover = function () {
  const totalA4LocalStorage = JSON.parse(localStorage.getItem('totalA4')) || {};
  const supportsLocalStorage = JSON.parse(localStorage.getItem('supports')) || [];

  $('#paper-popover').html('' +
    '<p>Amarelas: ' + (totalA4LocalStorage.yellow_paper || 0) + '</p>' +
    '<p>Brancas: ' + (totalA4LocalStorage.white_paper || 0) + '</p>'
  );
  const $collapseBudgetSummary = $('#collapse-budget-summary').find('.card-body .products');
  $collapseBudgetSummary.html('<p><strong>Total de folhas A4</strong></p>' +
    '<p>Amarelas: ' + (totalA4LocalStorage.yellow_paper || 0) + '</p>' +
    '<p>Brancas: ' + (totalA4LocalStorage.white_paper || 0) + '</p>' +
    '<p><strong>Suportes</strong></p>'
  );

  const $supportsPopover = $('#supports-popover');
  $supportsPopover.html('');
  supportsLocalStorage.forEach(function (support) {
    $supportsPopover.append('<p>' + support.title + ': ' + support.quantity + '</p>');
    $collapseBudgetSummary.append('<p>' + support.title + ': ' + support.quantity + '</p>');
  });
};

window.setTotalBudget = function (total, is_sum) {
  const totalLocalStorage = JSON.parse(localStorage.getItem('total')) || 0.0;
  let totalFloat = parseToFloat(total);
  if (is_sum) {
    totalFloat += totalLocalStorage;
  } else {
    totalFloat = Math.abs(totalLocalStorage - totalFloat);
  }
  $('.budget-total').text(formatMoney(totalFloat));
  localStorage.setItem('total', JSON.stringify(totalFloat));
};

window.formatMoney = function (money) {
  let money_number = Number.parseFloat(money);
  return money_number.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
};

window.toggleIcon = function (element) {
  const $element = $(element);
  if ($element.hasClass('fa-plus')) {
    $element.removeClass('fa-plus');
    $element.addClass('fa-minus');
  } else {
    $element.removeClass('fa-minus');
    $element.addClass('fa-plus');
  }
};

function gritter(message, type) {
  $.gritter.add({
    title: message.title,
    text: message.text,
    class_name: 'color ' + type,
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/store.js